var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbnailOverlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4851 2.6148C36.6372 2.6148 38.3881 4.36796 38.3881 6.52289V23.2183C38.3881 25.3732 36.6372 27.1264 34.4851 27.1264H17.8113C15.6592 27.1264 13.9083 25.3732 13.9083 23.2183V6.52289C13.9083 4.36796 15.6592 2.6148 17.8113 2.6148H34.4851ZM34.4851 0H17.8113C14.2135 0 11.2969 2.9204 11.2969 6.52289V23.2183C11.2969 26.8208 14.2135 29.7412 17.8113 29.7412H34.4851C38.0829 29.7412 40.9995 26.8208 40.9995 23.2183V6.52289C40.9995 2.92039 38.0829 0 34.4851 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3137 11.5039H7.51856C3.84619 11.5039 0.869141 14.4848 0.869141 18.162V32.976C0.869141 36.6531 3.84619 39.6341 7.51856 39.6341H22.3137C25.9861 39.6341 28.9631 36.6531 28.9631 32.976V18.162C28.9631 14.4848 25.9861 11.5039 22.3137 11.5039Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3133 12.3739C25.5058 12.3739 28.0937 14.9652 28.0937 18.1618V32.976C28.0937 36.1726 25.5058 38.764 22.3133 38.764H7.51828C4.32581 38.764 1.73788 36.1726 1.73788 32.976V18.1618C1.73788 14.9652 4.32581 12.3739 7.51828 12.3739H22.3133ZM22.3133 10.6338H7.51828C3.37265 10.6338 0 14.0109 0 18.1618V32.976C0 37.127 3.37265 40.5041 7.51828 40.5041H22.3133C26.4589 40.5041 29.8316 37.127 29.8316 32.976V18.1618C29.8316 14.0109 26.4589 10.6338 22.3133 10.6338Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailOverlay);
export default __webpack_public_path__ + "static/media/thumbnail-overlay.76837def63010138c47b33adcde46893.svg";
export { ForwardRef as ReactComponent };